<div class="valuation-event-properties-component" *ngIf="valuationPortfolioId > 0" [class.close]="shouldClose" [class.canClose]="canClose">
  <steps-manager *ngIf="canClose" [displayCloseButton] = "true" [stepsCount]="stepsCount" [currentStep]="currentStep" (onCloseClicked)="onCloseClicked()"></steps-manager>
  <div class="valuation-event-properties-container">
    <div class="groupby-icons">
      <div class="navigation-items action-items" [ngClass]="selectedProperty && selectedProperty.linkedToPortfolio && compsOptions ? 'navigation-border-right' : '' ">
        <div class="action-icon" (click)="setGroupingType(1)">
          <svg-icon src="./assets/icons/properties_by_region.svg" align="center" class="menu-action-icon" [ngClass]="groupingType === 1 ? 'svg-icon-red' : 'svg-icon-gray'"></svg-icon>
          <div class="icon-label" [innerHTML]="'projectToolbar.buttonPortfolioPropertiesByCountry' | translate | uppercase"></div>
        </div>
        <div class="action-icon" (click)="setGroupingType(2)">
          <svg-icon src="./assets/icons/arrow-down-short-wide-solid.svg" align="center" class="menu-action-icon" [ngClass]="groupingType === 2 ? 'svg-icon-red' : 'svg-icon-gray'"></svg-icon>
          <div class="icon-label" [innerHTML]="'projectToolbar.buttonPortfolioPropertiesByPropertyType' | translate | uppercase"></div>
        </div>
        <div class="action-icon" (click)="setGroupingType(3)">
          <svg-icon src="./assets/icons/Properties_icon.svg" align="center" class="menu-action-icon" [ngClass]="groupingType === 3 ? 'svg-icon-red' : 'svg-icon-gray'"></svg-icon>
          <div class="icon-label" [innerHTML]="'projectToolbar.buttonPortfolioPropertiesAll' | translate | uppercase"></div>
        </div>
      </div>
      <div class="navigation-items action-items" *ngIf="selectedProperty && selectedProperty.linkedToPortfolio && compsOptions">
        <div class="action-icon" (click)="showPreview()" *ngIf="showPreviewCompsButton">
          <svg-icon src='./assets/icons/eye-outline.svg' alt="SEARCH COMPS" title="{{'projectToolbar.showPreview' | translate | uppercase}}" class="menu-action-icon svg-icon-gray" align='center'></svg-icon>
          <div class="icon-label" [innerHTML]="'projectToolbar.showPreview' | translate | uppercase"></div>
        </div>
        <div class="action-icon" (click)="searchComparables()" *ngIf="showSearchCompButton" [class.isDisabled]="disableSearchCompsButton">
          <svg-icon src='./assets/icons/compass-outline.svg' alt="SEARCH COMPS" title="{{'projectToolbar.searchComparables' | translate | uppercase}}" class="menu-action-icon svg-icon-gray" align='center'></svg-icon>
          <div class="icon-label" [innerHTML]="'projectToolbar.searchComparables' | translate | uppercase"></div>
        </div>
        <div class="action-icon" *ngIf="showDeleteSearchCompButton" [class.isDisabled]="!disableDeleteSearchCompButton" (click)="showDeletePreview()" >
          <svg-icon src="./assets/icons/delete.svg" align="center" class="menu-action-icon svg-icon-gray" title="{{'projectToolbar.buttonDeleteConnectedComps' | translate | uppercase}}"></svg-icon>
          <div class="icon-label" [innerHTML]="'projectToolbar.buttonDeleteConnectedComps' | translate | uppercase"></div>
        </div>
      </div>
    </div>
    <div class="upper-text">
      <h2>{{'valuationEventProperties.properties' | translate | uppercase}}</h2>
      <h3>{{'valuationEventProperties.assignProperties' | translate}}</h3>
    </div>
      <div class="upper-text select-all-checkbox">
        <input [(ngModel)]="isSelectAllActive" (change)="checkAllCheckBox()" type="checkbox" class="custom-checbox" /> <label>Select all</label>
      </div>

    <div class="properties-view" [ngClass]="properties && properties.length > 20 && detailForm ? 'propertiesScrollbarDetailForm' : properties && properties.length > 20 && !detailForm ? 'propertiesScrollbarSlideIn' : ''"  *ngIf="groupingType === 3">
      <div class="properties-list">
        <ng-container [ngTemplateOutlet]="propertiesGrid"
                      [ngTemplateOutletContext]="{properties:properties}">
        </ng-container>
      </div>
    </div>

    <div *ngIf="groupingType !== 3" [ngClass]="properties && properties.length > 20 && detailForm ? 'propertiesScrollbarDetailForm' : properties && properties.length > 20 && !detailForm ? 'propertiesScrollbarSlideIn' : ''">
      <div class="properties-view" *ngFor="let group of groups">
        <div>
          <svg-icon src='{{groupingIcon}}'
                    class="menu-action-icon svg-icon-red"
                    align='center'>
          </svg-icon>
          <h4 class="properties-list-title" (click)="groupClicked(group)">
            {{group.groupName}}
          </h4>
        </div>
        <div class="properties-list-body">
          <div class="properties-list">
            <ng-container [ngTemplateOutlet]="propertiesGrid"
                          [ngTemplateOutletContext]="{properties:group.items}">
            </ng-container>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>

<ng-template #propertiesGrid let-properties='properties'>
  <table class="properties" aria-hidden="true">
    <thead>
      <tr>
        <th>&nbsp;</th>
        <th class="property-name-col">{{'valuationEventProperties.propertyName' | translate | uppercase}}</th>
        <th class="country-col" *ngIf="groupingType !== 1">{{'valuationEventProperties.country' | translate | uppercase}}</th>
        <th class="city-col">{{'valuationEventProperties.city' | translate | uppercase}}</th>
        <th class="address-col">{{'valuationEventProperties.address' | translate | uppercase}}</th>
        <th class="propertyType-col" *ngIf="groupingType !== 2">{{'valuationEventProperties.propertyType' | translate | uppercase}}</th>
        <th class="hasComparables-col">{{'valuationEventProperties.hasSalesComparables' | translate | uppercase}}</th>
        <th class="hasComparables-col">{{'valuationEventProperties.hasLeaseComparables' | translate | uppercase}}</th>
        <th class="hasComparables-col">{{'valuationEventProperties.hasIEComparables' | translate | uppercase}}</th>
        <th class="effectiveStartDate-col">{{'valuationEventProperties.effectiveStartDate' | translate | uppercase}}</th>
        <th class="effectiveEndDate-col">{{'valuationEventProperties.effectiveEndDate' | translate | uppercase}}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let property of properties" [class.linkedToPortfolio]="property.linkedToPortfolio">
        <td><input *ngIf="compsOptions" name="property" class="propertiesCheckbox" type="radio" (change)="onSelectedPropertyChange(property)" /></td>
        <td class="property-name-col" (click)="propertyChange(property)">{{property.propertyName}}</td>
        <td class="country-col" *ngIf="groupingType !== 1">{{property.country}}</td>
        <td class="city-col">{{property.city}}</td>
        <td class="address-col">{{property.address}}</td>
        <td class="propertyType-col" *ngIf="groupingType !== 2">{{property.propertyType}}</td>
        <td class="hasComparables-col">{{property.hasSalesComparables ? 'Yes' : 'No'}}</td>
        <td class="hasComparables-col">{{property.hasLeaseComparables ? 'Yes' : 'No'}}</td>
        <td class="hasComparables-col">{{property.hasIEComparables ? 'Yes' : 'No'}}</td>
        <td class="effectiveStartDate-col">{{property.valuationEventEffectiveStartDate | date: 'dd/MM/yyyy'}}</td>
        <td class="effectiveEndDate-col">{{property.valuationEventEffectiveEndDate | date: 'dd/MM/yyyy'}}</td>
      </tr>
    </tbody>
  </table>
</ng-template>
<properties-comparables-sidebar *ngIf="showPreviewSidebar"
                                [subjectPropertyId]="selectedProperty?.subjectPropertyId"
                                (closePane)="closeComparablesSidebar()"
                                [hasSalesComparables]="selectedProperty?.hasSalesComparables || compsSearchRequested"
                                [hasLeaseComparables]="selectedProperty?.hasLeaseComparables || compsSearchRequested"
                                [hasIEComparables]="selectedProperty?.hasIEComparables || compsSearchRequested"></properties-comparables-sidebar>
<properties-comparables-delete-sidebar *ngIf="showPreviewDeleteSidebar"
                                [selectedProperty]="selectedProperty"
                                (closePane)="closeComparablesDeleteSidebar()"
                                (disableDelete)="disableDelete()"
                                [hasSalesComparables]="selectedProperty?.hasSalesComparables || compsSearchRequested"
                                [hasLeaseComparables]="selectedProperty?.hasLeaseComparables || compsSearchRequested"
                                [hasIEComparables]="selectedProperty?.hasIEComparables || compsSearchRequested"></properties-comparables-delete-sidebar>
